
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'ピン',
	'find_label': '検索',
	'findCancelLabel': 'キャンセル',
	'dataPaneLabel': 'データ',
	'sourcePaneLabel': '選択されたソース',
	'sourcePaneContentLabel': 'ソースの選択',
	'emptySourcePaneTitle': 'ソースの選択',
	'emptySourcePaneCaption': 'クリックして、ダッシュボードのビルドに使用するデータを追加するソースを選択します。',
	'addDataSource': 'ソースの選択',
	'addDataDashboardCoachMarkContents': 'データ・パネルのデータをダッシュボードにドラッグ・アンド・ドロップします。',
	'addDataStoryCoachMarkContents': 'データ・パネルのデータをストーリーにドラッグ・アンド・ドロップします。',
	'addDataCoachMarkTitle': 'データの追加',
	'selectSourcesText': '%{app} を作成するには、データ・ソースを選択して追加します。',
	'selectSourcesLabel': 'ソースの選択',
	'dataPreparationTitle': 'データの準備',
	'dataPreparationCaption': 'データの準備が完了すると、こちらにデータが表示されます。',
	'dataPreparationProgress': '%{percentage}% 準備完了...',
	'dataPreparationSourceError': '"%{sourceName}" のデータ準備が正常に完了しませんでした。',
	'dataPreparationStarted': '"%{sourceName}" のデータ準備が進行中です。 ダッシュボード機能は、データの準備が完了すると使用可能になります。',
	'dataPreparationComplete': '"%{sourceName}" のデータ準備が完了しました。 これで、すべてのダッシュボードの機能で使用する準備ができました。',
	'preparingData': 'データの準備中...',
	'moserUnsupportedSourceType': 'このデータ・ソース・タイプはサポートされていません。',
	'errorSourcesTitle': 'データ・ツリーのロードに失敗しました',
	'errorLoadingDataSources': 'データ・セットのリストのロード中にエラーが発生しました',
	'errorLoadingDataTree': 'ツリーのロード中にエラーが発生しました',
	'dataSetPaneLastUpdated': '最終更新日: %{date}',
	'dataSourcePaneDateUnknown': '不明',
	'moreTitle': '詳細表示',
	'backLabel': '戻る',
	'addDataSourceDialogTitle': 'ソースの選択',
	'addDataSourceDialogButtonLabel': '追加',
	'dlg_use': '使用',
	'dlg_RelinkDataSourceTitle': 'データ・セット "%{dataSourceName}" を置換します...',
	'propertiesDialogTitle': 'プロパティー',
	'missingDataSetData': 'このデータ・セットのデータは使用できません。 このデータ・セットを更新するか、または管理者に連絡して、ソースにアクセスできるようにしてください。',
	'errorMessageTitle': 'エラー',
	'calculation_navigation_in_use': '計算、フィルター、またはナビゲーション・パスを削除すると、削除されたアイテムを参照するすべての視覚化が無効になります。 削除してもよろしいですか?',
	'delete_confirm': '削除の確認',
	'previewUnavailable': 'このパッケージ・タイプでは、データ・トレイおよびグローバル・フィルターは使用できません。',
	'contextualGridTabName': '視覚化データ',
	'DATA_TRAY_no_data_text': '現在データを持っていません',
	'contextualGridMenuLabel': '視覚化データ・メニュー',
	'contextualGridExport': 'エクスポート',
	'nullValueText': 'Null',
	'relationships_title': '関係',
	'forecastDetailsTabName': '予測の統計的詳細',
	'forecastDetailsModelLabel': 'モデル',
	'forecastDetailsQualityMetricLabel': '精度の数値データ',
	'forecastDetailsSmoothingCoefLabel': 'パラメーター',
	'forecastDetailsDiagnostics': '診断',
	'forecastDetailsForecastLabel': '予測',
	'forecastDetailsStatusLabel': 'ステータス',
	'forecastDetailsAccuracyPercentLabel': '精度 %',
	'forecastDetailsTrendLabel': 'トレンド',
	'forecastDetailsSeasonLabel': '季節性',
	'forecastDetailsSeasonalPeriodLabel': '季節期間',
	'forecastDetailsAlphaLabel': 'アルファ',
	'forecastDetailsBetaLabel': 'ベータ',
	'forecastDetailsGammaLabel': 'ガンマ',
	'forecastDetailsPhiLabel': 'ファイ',
	'forecastDetailsMissingCount': '欠落数',
	'forecastDetailsSeriesLengthLabel': '系列の長さ',
	'forecastDetailsIgnoredPeriods': '無視する期間',
	'forecastDetailsTrendStrength': 'トレンドの強さ',
	'forecastDetailsSeasonalityStrength': '季節性の強さ',
	'forecastDetailsTimeDeltaUnit': '日付 / 時刻の間隔',
	'forecastDetailsNotes': 'メモ',
	'DatasetRefresh_AmbiguousConnection': ' 「データ・セットの編集」を使用して、次の接続の問題を解決してください: %{errorMessage}'
});
